import AccidentTravailSource from '@/generated/controls/accidentTravail/AccidentTravailSource.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: AccidentTravailSource
})
